<template>
  <div class="app-footer">
    <div class="footer-content">
      <div class="footer-flex-left footer-right">
        <div class="footer-btn" @click="dialogVisible = true">申请样品</div>
        <router-link to="/productDisplay" class="footer-btn">查看产品资料</router-link>
      </div>
      <div class="footer-flex footer-flex-content footer-right">
        <div><router-link to="/">首页</router-link></div>
        <div><router-link to="/about">关于盛世行</router-link></div>
        <div><router-link to="/productDisplay">产品展示</router-link></div>
        <div><router-link to="/recruit">人才招聘</router-link></div>
        <div><router-link to="/contact">联系我们</router-link></div>
      </div>
      <div class="footer-flex footer-flex-content">
        <div>公司：广州盛世行新材料有限公司 保留所有权利</div>
        <div>联系电话：13922549234</div>
        <div>地址：广州市番禺区番禺大道北555号天安科技交流中心902室</div>
        <div><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备2024274783号-1</a></div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" width="1080px">
      <span style="color: #061D48;font-size: 24px;line-height: 40px;">我们努力，将最新的信息展现在您的面前，请尽情书写您的需求、留下您的联系方式，我们
        有专人回复您。</span>
      <div class="sampleBg">
        <div>申请样品</div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <div class="form_flex">
            <el-form-item label="姓名" prop="user_name">
              <el-input v-model="ruleForm.user_name" placeholder="请填写姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请填写电话"></el-input>
            </el-form-item>
          </div>
          <div class="form_text">
            <el-form-item label="留言" prop="reason">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 5}" :rows="5" show-word-limit maxlength="200" placeholder="请填写您想对我们说的话..." v-model="ruleForm.reason">></el-input>
            </el-form-item>
          </div>
          <div style="text-align: center;margin-top: 60px;">
            <el-button type="primary" @click="submitForm('ruleForm')">立即申请</el-button>
          </div>

        </el-form>
      </div>

    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        user_name: '',
        phone: '',
        reason: ''
      },
      rules: {
        user_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入正确电话号码', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^(13[0-9]|14[0-9]|15[0-9]|16[6]|18[0-9]|19[6,9]|17[0-9])\d{8}$/i.test(value) == false) {
                callback(new Error("请输入正确电话号码"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        reason: [
          { required: true, message: '请输入留言', trigger: 'blur' },
        ],
      },

      dialogVisible: false,
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {

        if (valid) {
          this.$axios.post(this.$api.push_record, this.ruleForm).then(res => {
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.resetForm(formName)
              this.dialogVisible = false;
            } else {
              this.$message({
                message: res.data.msg,
              })
            }
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  padding: 50px 0px;
  background-color: #334f82;
  font-size: 20px;
  box-sizing: border-box;
  ::v-deep .el-dialog__body {
    padding: 50px 60px !important;
    box-sizing: border-box;
  }
  ::v-deep .el-dialog__headerbtn {
    font-size: 26px;
  }
  .el-button {
    width: 460px;
    height: 60px;
    background: #1e50ae;
    box-shadow: 0px 2px 6px 1px rgba(30, 80, 174, 0.5);
    border-radius: 31px 31px 31px 31px;
    ::v-deep span {
      font-size: 24px;
    }
  }
  .form_flex {
    display: flex;
    justify-content: space-between;
    div {
      flex: 0 0 45%;
    }

    ::v-deep .el-input__inner {
      border-radius: 35px;
    }
    ::v-deep .el-form-item__label {
      font-size: 24px;
      color: black;
    }
  }
  .form_text {
    ::v-deep .el-textarea__inner {
      padding: 13px 15px;
      border-radius: 35px;
    }
    ::v-deep .el-form-item__label {
      font-size: 24px;
      color: black;
    }
    .el-textarea ::v-deep .el-input__count {
      background: none;
    }
  }
}
.sampleBg {
  height: 70px;
  line-height: 70px;
  color: #ffffff;
  font-size: 30px;
  margin: 30px 0;
  text-align: center;
  background-image: url("../assets/img/sample.png");
  background-size: 100% 100%;
}
.footer-content {
  display: flex;
  max-width: calc(1920px - 640px);
  margin: 0 auto;
  color: #ffffff;

  .footer-flex {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .footer-right {
    margin-right: 120px;
  }
  .footer-flex-left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .footer-btn {
      width: 280px;
      height: 110px;
      line-height: 110px;
      font-size: 24px;
      text-align: center;
      background-image: url("../assets/img/footer_btn.png");
      background-size: 100% 100%;
      cursor: pointer;
      display: block;
    }
  }
  .footer-flex-content {
    div:not(:last-child) {
      margin-bottom: 38px;
    }
  }
}
</style>